import { FLAG } from "../constants/Constants";

const PLAN_TYPE = {
  FREE: 0,
  // LETTER: 1, DBで使わないようにするのでコメントアウト
  // EXPORT: 2, DBで使わないようにするのでコメントアウト
};

/**
 * このファイルにはLetterPlanテーブルの列に関わる処理を定義しています。
 * TODO utils/utils.jsにユーザー関連が多くあるので、本ファイルに移行する
 */

/**
 * 有効期限内のアクティブなプランか
 * @see バックエンドの仕様でtrueの場合は有効期限内の期間と同義
 * @param {object} user ユーザー
 * @return {bool}
 */
const hasActivePlan = (user) => {
  return (user && user.active_plan) ? true : false;
}

export const getPlanName = (user) => {
  return (hasActivePlan(user)) ? user.active_plan['name'] : '';
}

/**
 * フリープランかどうかを判定
 * @param {object} user ユーザー
 * @return {bool}
 */
export const isFreePlan = (user) => {
  return (hasActivePlan(user)) ? (user.active_plan.plan_type === PLAN_TYPE.FREE) : false;
}

/**
 * キーマンデータベースが表示できるかどうかを判定
 * @param {object} user ユーザー
 * @return {bool}
 */
export const isEnabledDisplayExecutiveList = (user) => {
  return (hasActivePlan(user)) ? user.active_plan.use_exe_flag === FLAG.ON : false;
}

/**
 * 手紙送付が可能かどうかを判定
 *
 * @param {object} user ユーザー
 * @return {bool}
 */
export const isEnabledSendLetter = (user) => {
  return (hasActivePlan(user)) ? (user.active_plan.send_letter_flag === FLAG.ON) : false;
}

/**
 * キーマンデータベースをエクスポートできるかどうかを判定
 *
 * @param {object} user ユーザー
 * @return {bool}
 */
export const isEnabledExportExecutiveList = (user) => {
  return (hasActivePlan(user)) ? (user.active_plan.export_flag === FLAG.ON) : false;
}

/**
 * 過去に一度でもエクスポート可能なプランを契約していたかどうかを判定
 * 現在のアクティブなプランだけでなく、過去のプラン契約履歴（user.plans）も対象とする。
 * ダウンロード履歴メニューの表示可否判定に利用する。
 *
 * @param {object} user ユーザー
 * @return {bool}
 */
export const hasEverBeenEnabledExportPlan = (user) => {
  // 現在エクスポート可能なプランであればtrue
  if (isEnabledExportExecutiveList(user)) {
    return true;
  }

  // 過去のプラン契約履歴にエクスポート可能なプランがあればtrue
  return !!(user && user.plans && user.plans.some(plan => plan.export_flag === FLAG.ON));
}

/**
 * エクスポート可能件数を取得
 * @param {object} user ユーザー
 * @returns {number} 年間
 */
export const getMaxExportCount = (user) => {
  return (hasActivePlan(user) && user.active_plan.max_export_num > 0) ? user.active_plan.max_export_num : Infinity;
}

/**
 * 送付可能通数を取得
 * @param {object} user ユーザー
 * @returns {number} 年間
 */
export const getMaxSendLetterCount = (user) => {
  return (hasActivePlan(user) && user.active_plan.max_annual_letter_num > 0) ? user.active_plan.max_annual_letter_num : Infinity;
}



// WEBPACK FOOTER //
// ./src/utils/planUtils.js